import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { PayloadAction } from '@reduxjs/toolkit';
import { MetalTypeEnum } from '~utils/enums';

export default function* watchGetBranchInventories(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetBranchInventoriesAttempt', handleGetBranchInventories, api);
}

function* handleGetBranchInventories(api: GoldGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        branchName,
        metalType,
        goldType,
        silverType,
        ...rest
    } = reduxState.gold.params.inventoryFilterParams;

    const params = {
        ...rest,
        metalType,
        ...(metalType === MetalTypeEnum.Gold
            ? { goldType }
            : { silverType }),
    };

    const response = yield* call([api, api.getAllInventories], {
        authToken,
        ...params,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldGetBranchInventoriesFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldGetBranchInventoriesSuccess(response.data));
    }
}
